export const CONSENT_COOKIE = 'consentCookie'
